import { Pipe, PipeTransform } from '@angular/core';



const resultLookup = {
  0: 'phone_iphone', //MOBILE(0),
  1: 'devices', //SOFT(1),
  2: 'computer', //DESKTOP(2),
  3: 'call_received', //FXS(3),
  4: 'call_received', //EXTERNAL_PBX(4),
  //5: '', //??(5)
  6: 'fax', //FAX(6),
  7: 'voicemail', //VOICEMAIL(7),
  8: 'call_received', //EXTERNAL(8),
  9: 'phone_iphone', //MOBILE_EXT(9),
  10: 'groups', //CONFERENCE(10),
  11: 'people_alt', //QUEUE(11),
  //12: '', //??(12)
  13: 'language', //WEB(13)
};



@Pipe({
  name: 'telepoCdrApTypePipe_Icon'
})
export class TelepoCdrApTypePipe_Icon implements PipeTransform {
  transform(value: string): any {
    
    return resultLookup[value] ?? "call";
  }
}
